export default __webpack_public_path__ + "static/media/Quick request form.aaa16687.png";